import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { Markup } from 'interweave';
import './css/featurettes.css';

const SingleTrainerFeaturetteComponentOdd = (props) => (
    <Container>
        <hr></hr>
            <div className="row featurette align-items-center">
                <div className="col-md-5">
                    <img className="featurette-image img-responsive" src={`img/${props.trainer.photo}`} alt={`${props.trainer.firstname} ${props.trainer.lastname}`} />
                </div>
                <div className="col-md-7">
                    <h2 className="featurette-heading">{props.trainer.firstname} {props.trainer.lastname}. <span
                        className="text-muted">Trainer.</span></h2>
                    <p className="lead text-justify small"><Markup content={props.trainer.bio}/></p>
                </div>
            </div>
    </Container>
);

const SingleTrainerFeaturetteComponentEven = (props) => (
    <Container>
        <hr></hr>
            <div className="row featurette align-items-center">
                <div className="col-md-7">
                    <h2 className="featurette-heading">{props.trainer.firstname} {props.trainer.lastname}. <span
                        className="text-muted">Trainer.</span></h2>
                    <p className="lead text-justify small"><Markup content={props.trainer.bio}/></p>
                </div>
                <div className="col-md-5">
                    <img className="featurette-image img-responsive" src={`img/${props.trainer.photo}`} alt={`${props.trainer.firstname} ${props.trainer.lastname}`} />
                </div>
            </div>
    </Container>
);

class Featurettes extends Component {

    constructor(props) {
        super(props);

        this.state = {
            error: null,
            isLoaded: false,
            items: []
        };
    }

    componentDidMount() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
        //fetch("http://192.168.1.9:8181/api/v1/trainers", {
        fetch("/api/v1/trainers", {
            //method: "POST", // *GET, POST, PUT, DELETE, etc.
            //mode: "cors", // no-cors, cors, *same-origin
            //cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            //credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Accept": "application/json",
                // "Content-Type": "application/json",
                // "Content-Type": "application/x-www-form-urlencoded",
            },
            //redirect: "follow", // manual, *follow, error
            //referrer: "no-referrer", // no-referrer, *client
            //body: JSON.stringify(data), // body data type must match "Content-Type" header

        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        items: result
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    render() {
        const { error, isLoaded, items } = this.state;

        if (error) {
            return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Loading...</div>;
        } else {
            let trainerComponents = [],
                temparray = [];

            for (let i = 0; i < items.length; i++) {
                temparray.trainer = items[i];

                if (temparray.trainer.id % 2 === 0) {
                    trainerComponents.push(<SingleTrainerFeaturetteComponentEven {...temparray} />);
                } else {
                    trainerComponents.push(<SingleTrainerFeaturetteComponentOdd {...temparray} />);
                }
            }

            return (
                <div className="container">
                    <h2>Our Team of Trainers</h2>
                    {trainerComponents}
                </div>
            );
        }
    }
}

export default Featurettes;